<cmps-dialog>
    <cmps-dialog-header
        [hasExpandAction]="true"
        [expandTooltip]="_i18n._11136_EXPAND_WINDOW | translate"
        [collapseTooltip]="_i18n._11137_COLLAPSE_WINDOW | translate"
        [closeTooltip]="_i18n._11135_CLOSE_WINDOW | translate"
    >
        <cmps-teamscall-auth [showLogin]="false">
            <div class="header">
                <div
                    class="row"
                    *ngIf="!state?.hasPendingData && state?.errorCode == null"
                >
                    <input
                        type="text"
                        class="col topic"
                        [ngModel]="state?.chat?.topic"
                        [ngModelOptions]="{ updateOn: 'blur' }"
                        (ngModelChange)="_onTopicChange($event)"
                    />
                    <button
                        Class="add-notes"
                        cmpsButton
                        [cmpsTooltipTrigger]="
                            _i18n._11132_CREATE_COACHING_NOTES_FROM_CHAT_CONVERSATION
                                | translate
                        "
                        trigger="hover"
                        (click)="_onAddNotesClick()"
                    >
                        <cmps-icon svgIcon="note-plus-outline"></cmps-icon>
                        <span cmpsButtonLabel>{{
                            _i18n._11037_ADD_NOTES | translate
                        }}</span>
                    </button>
                </div>
            </div>
        </cmps-teamscall-auth>
    </cmps-dialog-header>
    <cmps-teamscall-auth
        [class.cmps-cdk-d-block]="authRef.hasValidToken !== true"
        [class.cmps-cdk-pt-0dot5]="authRef.hasValidToken !== true"
        [class.cmps-cdk-text-center]="authRef.hasValidToken !== true"
        (hasValidTokenChange)="_onHasValidTokenChange($event)"
        #authRef
    >
        <cmps-wait-status *ngIf="state.hasPendingData"></cmps-wait-status>
        <ng-container *ngIf="!state.hasPendingData">
            <div class="focus">{{ state.behaviour }};</div>
            <div class="focus">{{ state.subBehaviour }}</div>
        </ng-container>
        <cmps-dialog-body>
            <div
                *ngIf="state?.errorCode != null && state?.errorCode !== 0"
                class="status-message"
            >
                {{ _i18n._11139_CHAT_CAN_NOT_BE_CREATED | translate }}
                <br /><br />
                {{
                    _i18n._11140_AN_EMAIL_IS_UNREGISTERED_WITHIN_THE_MICROSOFT_TENANT
                        | translate
                }}
            </div>
            <div
                *ngIf="state?.errorCode !== null && state.hasPendingData"
                class="status-message"
            >
                {{ _i18n._11196_CONNECTING_TO_MS_TEAMS | translate }}
            </div>
            <div
                class="body"
                *ngIf="!state?.hasPendingData"
            >
                <ng-container *ngFor="let bubble of state.conversation">
                    <div
                        *ngIf="bubble.isUser"
                        class="row chat-message-user reveal"
                    >
                        <div class="message-user">
                            <div>
                                {{
                                    bubble.startTime
                                        | cmpsDate: 'MMMM dd, YYYY h:mm a'
                                }}
                            </div>
                            <div class="row user-row">
                                <div class="hide">
                                    <button
                                        class="cmps-icon-button--no-bg"
                                        cmpsIconButton
                                        [cmpsMenuTrigger]="userMenu"
                                        placement="bottom-right"
                                    >
                                        <cmps-icon
                                            svgIcon="dots-vertical"
                                        ></cmps-icon>
                                    </button>
                                    <cmps-menu #userMenu="cmpsMenu">
                                        <button
                                            class="cmps-button--no-bg cmps-button--left"
                                            cmpsButton
                                            (click)="
                                                _onCopyClick(bubble.message)
                                            "
                                        >
                                            <span cmpsButtonLabel>{{
                                                _i18n._11130_COPY_MESSAGE
                                                    | translate
                                            }}</span>
                                        </button>
                                        <button
                                            class="cmps-button--no-bg cmps-button--left"
                                            cmpsButton
                                            (click)="_onDeleteClick(bubble)"
                                        >
                                            <span cmpsButtonLabel>{{
                                                _i18n._11131_DELETE_MESSAGE
                                                    | translate
                                            }}</span>
                                        </button>
                                    </cmps-menu>
                                </div>
                                <div class="bubble-user">
                                    <div class="text">{{ bubble.message }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="avatar">
                            <img
                                class="avatar-img"
                                src="{{ bubble.avatar }}"
                                *ngIf="bubble.avatar"
                            />
                            <div *ngIf="!bubble.avatar">
                                <cmps-icon
                                    svgIcon="account-circle"
                                    class="avatar-placeholder ml-2"
                                ></cmps-icon>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="!bubble.isUser"
                        class="row chat-message reveal"
                    >
                        <div class="avatar">
                            <img
                                class="avatar-img"
                                src="{{ bubble.avatar }}"
                                *ngIf="bubble.avatar"
                            />
                            <div *ngIf="!bubble.avatar">
                                <cmps-icon
                                    svgIcon="account-circle"
                                    class="avatar-placeholder mr-4"
                                ></cmps-icon>
                            </div>
                        </div>
                        <div class="message">
                            <div class="row">
                                <div>
                                    <div class="name">
                                        {{ bubble.msftDisplayName }}
                                    </div>
                                    {{
                                        bubble.startTime
                                            | cmpsDate: 'MMMM dd, YYYY h:mm a'
                                    }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="bubble">
                                    <div class="text">{{ bubble.message }}</div>
                                </div>
                                <div class="hide">
                                    <button
                                        class="cmps-icon-button--no-bg"
                                        cmpsIconButton
                                        [cmpsMenuTrigger]="menu"
                                        placement="bottom-left"
                                    >
                                        <cmps-icon
                                            svgIcon="dots-vertical"
                                        ></cmps-icon>
                                    </button>
                                    <cmps-menu #menu="cmpsMenu">
                                        <button
                                            class="cmps-button--no-bg cmps-button--left"
                                            cmpsButton
                                            (click)="
                                                _onCopyClick(bubble.message)
                                            "
                                        >
                                            <span cmpsButtonLabel>{{
                                                _i18n._11130_COPY_MESSAGE
                                                    | translate
                                            }}</span>
                                        </button>
                                    </cmps-menu>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </cmps-dialog-body>
        <div
            class="footer"
            *ngIf="!state?.hasPendingData && state?.errorCode == null"
        >
            <form
                #f="ngForm"
                (ngSubmit)="_onSubmit(f)"
                *ngIf="!state?.hasPendingData"
            >
                <div class="row input-row">
                    <textarea
                        class="col input"
                        type="text"
                        name="message"
                        autocomplete="off"
                        [placeholder]="_i18n._11036_ENTER_YOUR_TEXT | translate"
                        [(ngModel)]="_inputMessage"
                        (keyup)="_onInputChange($event)"
                        (keydown.enter)="$event.preventDefault(); _onSubmit(f)"
                        (keydown.shift.enter)="
                            $event.preventDefault(); _onShiftEnterClick()
                        "
                    ></textarea>
                    <button
                        class="emoji"
                        type="button"
                        (click)="_isEmojiPickerVisible = !_isEmojiPickerVisible"
                    >
                        <cmps-icon svgIcon="emoticon-outline"></cmps-icon>
                    </button>
                    <br />
                    <emoji-mart
                        class="emoji-mart emoji-picker"
                        *ngIf="_isEmojiPickerVisible"
                        (emojiSelect)="_onEmojiSelect($event)"
                        (appClickOutside)="_onOutsideClick()"
                        [title]="_i18n._11134_SELECT_YOUR_EMOJI | translate"
                        set="google"
                        totalFrequentLines="1"
                    ></emoji-mart>
                    <button
                        class="send"
                        type="submit"
                    >
                        <cmps-icon svgIcon="send"></cmps-icon>
                    </button>
                </div>
            </form>
        </div>
    </cmps-teamscall-auth>
</cmps-dialog>
